"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var buttons_1 = __importDefault(require("./buttons"));
var colors_1 = __importDefault(require("./colors"));
var dimensions_1 = __importDefault(require("./dimensions"));
var forms_1 = __importDefault(require("./forms"));
var grids_1 = __importDefault(require("./grids"));
var links_1 = __importDefault(require("./links"));
var styles_1 = __importDefault(require("./styles"));
var text_1 = __importDefault(require("./text"));
var typography_1 = __importDefault(require("./typography"));
exports.theme = __assign(__assign(__assign({ colors: colors_1.default }, typography_1.default), dimensions_1.default), { styles: styles_1.default,
    // Components
    buttons: buttons_1.default,
    forms: forms_1.default,
    grids: grids_1.default,
    links: links_1.default, 
    // Decoration
    radii: [
        0,
        3,
        6,
        12
    ], text: text_1.default });
